export default __webpack_public_path__ + "static/media/asko.524637af.svg";